import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
	WithStyles,
	createStyles,
	Typography,
	Paper,
	Grid,
	Checkbox,
	Chip,
	LinearProgress,
	Tooltip,
	Modal,
	Fade,
	Backdrop
} from '@material-ui/core';


import { MyPATLink, dateService } from '../../common';
import ContentData from '../types/ContentData';
import ContentDataDefault from '../types/ContentDataDefault';
import { StarSharp } from '@material-ui/icons';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { CONTENT_TYPE } from '../../course-Management/Constants/constants';
import moment from 'moment';
import { AUTHORING_CONTENT_TYPES, CONTENT_STATUS, titleCase } from '../../../constants/comman';
import { CARD_STATUS, CARD_INFO_TYPES, CONTENT_CARD_MODAL_HEADERS } from '../constant/content';
import { getDiffOnTwoDates, getPropertyValue } from '../../../utils';
import { FEEDBACK_VALIDATOR_ACTIONS, VALIDATION_ACTION_DAYS } from '../helper/contentValidation';


const styles = (theme: Theme) => createStyles({
	videoBorder: {
		borderLeft: 'solid 6px #F8AA4B'
	},
	notesBorder: {
		borderLeft: 'solid 6px #B881E3'
	},
	testBorder: {
		borderLeft: 'solid 6px #F49393'
	},
	questionBorder: {
		borderLeft: 'solid 6px #78D2A7'
	},
	cppBorder: {
		borderLeft: 'solid 6px #FA781A'
	},
	assignmentBorder: {
		borderLeft: 'solid 6px #1082D4'
	},
	workbookBorder: {
		borderLeft: 'solid 6px #60768C'
	},
	archive:{
		borderLeft: 'solid 6px #FFB341;'
	},
	cardFooter: {
		padding: '5px',
		background: 'rgb(246, 246, 246)',
		borderRadius: 4
	},
	cardLeftSection: {
		maxWidth: '6%',
		minWidth: '90px',
		position: 'absolute',
		marginTop: 2
	},
	cardRightSection: {
		paddingLeft: '6%',
		width: '100%',
		textDecoration: 'none'
	},
	hideSelectOption:{
		paddingLeft:'2%'
	},
	draftElements: {
		'&>:nth-child(1)': {
			paddingRight: 5,
			textAlign: 'right'
		}
	},
	paper: {
		background: 'rgb(255, 255, 255)',
		boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
		borderRadius: 8,
		margin: "4px 0px 12px",
		overflow: 'hidden',
		transition: 'all .3s ease-out',
		'& .content-status': {
			display: 'block'
		},
		'& .content-preview': {
			display: 'none'
		},
		'&:hover': {
			boxShadow: '0px 4px 10px 0px #babfc5',
			transition: 'all .3s ease-in',
		}
	},
	checkbox: {
		padding: theme.spacing.unit / 4,
		top: 0,
		left: 2,
		width: 16,
		height: 16,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		backgroundColor: '#fff',
		border: '1px solid #979797',
		borderRadius: 2,
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		}
	},
	checkedCheckbox: {
		backgroundColor: '#1d7dea',
		border: '1px solid #1d7dea',
		borderRadius: 2,
		color: '#99a1a7',
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 0,
			left: 4,
			width: 4,
			height: 8,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	primaryColor: {
		color: 'rgb(29 125 234)'
	},
	chipLabel: {
		display: 'block',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		fontFamily: '"Nunito", sans-serif',
		textOverflow: 'ellipsis',
		fontWeight: 400,
		fontSize: 12,
		color: '#60768C',
		textTransform: 'capitalize'
	},
	favourite: {
		padding: 0,
		margin: '0px 16px'
	},
	favouriteIcon: {
		fontSize: 22,
		fontFamily: '"Nunito", sans-serif',
		fill: '#FDCC0C'
	},
	gridSpacing28: {
		width: 'calc(100% + 0px)',
		margin: '-12px 12px'
	},
	textEllipsis: {
		maxWidth: 'calc(100% - 200px)',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		paddingRight: theme.spacing.unit,
		fontSize: '16px',
		fontWeight: 'normal',
		color:'#333',
	},
	title: {
		lineHeight: theme.spacing.unit * 4 + "px",
		color: '#333333',
		fontWeight: 400,
		paddingRight: 0,
		fontSize: 16,
	},
	concept: {
		opacity: 0.8,
		lineHeight: theme.spacing.unit * 4 + "px",
	},
	contentTypeIcon: {
		display: 'inline-block',
		verticalAlign: 'middle',
		padding: '10px 0px'
	},
	subtypeIcon:{
		display: 'inline-block',
		verticalAlign: 'middle',
		padding: '10px 0px',
		height: '40px'
	},
	subTitle: {
		padding: '8px 0px 4px 0px',
		color: '#333'
	},
	contentType: {
		padding: '3px 0px',
		maxWidth: 126,
		background: '#FFF',
		border: '1px solid #60768C',
		boxSizing: 'border-box',
		borderRadius: 10,
		height: 20,
		margin: '6px 10px'
	},
	contentProgress: {
		display: 'inline-block',
		width: '100px',
		height: '12px',
		borderRadius: '5px',
		background: theme.palette.background.default,
		marginRight: '2px',
		'& span': {
			background: '#E8E8E8',
			borderRadius: '5.5px 5px 5px 5.5px',
			display: 'block',
			height: '100%'
		}
	},
	statusButton: {
		color: '#1D7DEA',
		padding: '2px 8px 2px !important',
		fontSize: 12,
		border: '1px solid #1D7DEA',
		boxSizing: 'border-box',
		borderRadius: 10,
		fontWeight: 600,
		display:"inline-block",
		marginRight:10,
	},
	mainContentArea: {
		position: 'relative',
		padding: '8px 20px 8px 10px',
		cursor: 'pointer',
		zIndex: 1,
	},
	publishButton: {
		background: '#FFF',
	},
	inReviewButton: {
		background: '#B3B4B3',
	},
	liveButton: {
		background: '#FFF',
		color: '#67BF02',
		border: '1px solid #67BF02'
	},
	plannedButton: {
		background: '#fff',
		color: '#979797',
		border: '1px solid #979797',
	},
	deleteButton: {
		background: '#CCCCCC',
	},
	rejectedButton: {
		background: '#fff',
		color: '#EC1C24',
		border: '1px solid #EC1C24',
	},
	draftButton: {
		background: '#fff',
		border: '1px solid #F4B40D',
		color: '#F4B40D',
	},
	approveButton: {
		background: '#fff',
		border: '1px solid #0f9402',
		color: '#0f9402',
	},
	inReview:{
		background: '#fff',
		border: '1px solid #F2982E',
		color: '#F2982E',
	},
	accepted: {
		background: '#fff',
		border: '1px solid #9cef1d',
		color: '#9cef1d',
	},
	paddingSm: {
		padding: '10px 6px 0px'
	},
	previewButton: {
		background: theme.palette.common.white,
		border: '1px solid #DDDDDD',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
		padding: theme.spacing.unit,
		paddingTop: 2,
		opacity: 0.7,
		'& svg': {
			marginRight: theme.spacing.unit
		}
	},
	statusText: {
		textTransform: 'capitalize',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		fontSize: 14,
		color: '#999999',
		fontWeight: 'normal',
		padding: '4px 0px',
		'& strong': {
			fontWeight: 'normal',
			color: '#666666'
		}
	},
	classSubjectShow:{
		maxWidth:86,
		overflow:'hidden',
		textOverflow:'ellipsis',
		whiteSpace:'nowrap',
		display:'inline-block',
		fontWeight:400,
		color:'#666666',	
	},
	viewDetails: {
		fontSize: 14,
		color: 'rgb(51 51 51)',
		cursor: 'pointer',
		paddingLeft: 6,
		maxWidth: 120,
		'& .infoContainer': {
			position: 'absolute',
			width: '90%',
			left: 100,
			bottom: 16,
			display: 'none',
			'&>:first-child': {
				background: 'rgb(222 222 222)',
				color: '#000',
				fontWeight: 600,
				maxWidth: '90%'
			}
		}
	},
	borderRightPublished: {
		borderRight: 'solid #3399F7 10px'
	},
	borderRightLive: {
		borderRight: 'solid #8ECE30 10px'
	},
	borderRightInReview: {
		borderRight: 'solid #B3B4B3 10px'
	},
	borderRightPlanned: {
		borderRight: 'solid #FF830F 10px'
	},
	colorSecondary: {
		backgroundColor: '#EB4F4F',
		color: '5.5px 5px 5px 5.5px'
	},
	progressBar: {
		borderRadius: 5
	},
	linearProgressBar: {
		borderRadius: 5,
		padding: 2,
		margin: '4px 18px',
		backgroundColor: '#E8E8E8',
		width: 54,
		marginLeft: 5,
	},
	// Variation Queation card
	grayCard:{
		backgroundColor: '#F8F8F8',
		borderRadius: 8,
		marginBottom: 8,
		padding: '8px 14px',
		width: '100%',
		position: 'relative',
	},
	variationCardChekbox:{
		position: 'absolute',
		left: '-5%',
	},
	quesHeading:{
		color: '#999',
		fontSize: '16px',
		lineHeight: '140%',
		margin: '5px 0 4px 0',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		width: '90%',
		'&>:first-child':{
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			width: '100%',
			margin: 0,
		}
	},
	quesNumber:{
		color: '#333',
		fontSize: '16px',
		fontWeight: 600,
		'&>span':{
			color: '#666',
		},
	},
	creatorName:{
		color: '#999',
		fontSize: '14px',
		fontWeight: 600,
		'&>span':{
			color: '#515C65',
		},
	},
	collapseLink:{
		zIndex: 9,
		position: 'absolute',
    	right: '10px',
		'&>:first-child':{
			fontSize: '14px',
			fontWeight: 600,
			color: '#1d7dea',
			marginRight: 8,
			'&:hover':{
				textShadow: '2px 2px 4px #d1d1d1'
			}
		},
		'&>img':{
			marginLeft: '4px',
		},
	},
	arrowIcon:{
        '&>img':{
            transform: 'rotate(180deg)',
            // marginLeft: '43px',
        }
    },
    rotateImg:{
        transform: 'rotate(0deg)',
	},
	slideDownAnimation:{
		transition: '0.5s',
	},
	width90Per:{
		width: '90%'
	},
	alignRight:{
		textAlign:'right',
	},
	classSubject:{
		display:'flex',
		flexDirection:'row',
		paddingLeft: '10px',
		'& p':{
			position:'relative',
			display:'flex',
			flexDirection:'row',
			alignItems:'center',
			'& span':{
				color:'#666',
				fontSize:14,
				'font-weight':'400',
				lineHeight:'22px',
				position:'relative',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				minWidth: '20px',
				maxWidth: '150px',
				display:'inline-block',
				'&:hover':{
					color:'#1d7dea',
				},
			},
			
		},
	},
	dotCircle:{
		content:"''",
		width:4,
		height:4,
		borderRadius:5,
		display:'inline-block',
		background:'#D9D9D9',
		margin:'0 8px',
		verticalAlign:'middle',
	},
	plusSign:{
		fontStyle:'normal',
		fontSize:14,
		color:'#1d7dea',
		cursor:'pointer',
		display:'inline-block',
	},
	lastUsedStrip:{
	width: '100%',
	padding: '5px 10px',
	textAlign: 'center',
	color: '#999',
	fontSize: '14px',
	'font-weight': '500',
	'line-height': '150%',
	borderRadius: '4px',
	background: 'rgba(242, 60, 60, 0.10)',
		'& b': {
			color:'#666',
		}, 
	},
	dueText: {
		padding: '5px 10px',
		backgroundColor: '#F4F4F4',
		borderRadius: 20,
		fontSize: '12px',
		fontWeight: 400,
		color: '#EC1C24',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		lineHeight: '120%',
		height:24,
		marginTop:3,
		'& img': {
			marginRight: '5px',
			width: '12px',
		}
	},
	paragraphInfo: {
		fontSize: '14px',
		fontWeight: 400,
		textAlign: 'center',
		color: '#666666'
	},
	paragraphCount: {
		color: '#1D7DEA',
	},
	lightTooltip: {
		wordBreak: 'break-all'
	},
	paragraphTooltip: {
		maxWidth: '335px',
	},
	resultRegeneration: {
		width: '100%',
		padding: '5px 10px',
		textAlign: 'center',
		color: '#999',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '150%',
		borderRadius: '4px',
		background: 'rgba(242, 60, 60, 0.10)',
	},
	customModalBox: {
		background: 'rgb(255, 255, 255)',
		borderRadius: 4,
		margin: "4px 0px 12px",
		overflow: 'hidden',
		position:'fixed',
		width:548,
		left:'calc(50% - 274px)',
		top:'calc(50% - 274px)',
		padding:'30px 0 30px 30px',
		'& h2':{
			margin: '0 30px 0 0',
			padding: '0 0 20px 0',
			color: '#000',
			fontSize: '24px',
			fontStyle: 'normal',
			'font-weight': '600',
			lineHeight: 'normal',
			textTransform: 'capitalize',
			textAlign: 'center',
			position: 'relative',
			'& span':{
				position:'absolute',
				right:'-10px',
				top:'-10px',
				cursor:'pointer',
			},
		},
		'&:focus-visible':{
			outline:0,
		},
	},
	plusMorePopup:{
		width:'100%',
		background:'#ffffff',
		padding:0,
		'& ul':{
		  listStyleType:'none',
		  padding:'0 0 20px 0',
		  margin:'0 30px 0 0',
		  display:'flex',
		  flexDirection:'row',
		  '& li':{
			marginRight:'20px',
			cursor:'pointer',
			padding:'5px 20px',
			borderRadius: 50,  
			background: '#F4F4F4',
			color: '#666',
			textAlign: 'center',
			fontSize: '14px',
			fontStyle: 'normal',
			'font-weight': '400',
			lineHeight: 'normal',
		  },
		},
	},
	
	tableWrapper:{
		minHeight:100,
		maxHeight:350,
		paddingRight:30,
	},
	tableTagList:{
		border:'solid 1px #e6e6e6',
		borderTop:0,
		width:'100%',
		'& thead':{
			position: 'sticky',
			top: '0',
			left: '0',
			background: '#fff',
			borderTop:'solid 1px #e6e6e6',
		},
		'& thead th':{
			color: '#333',
			fontSize: '14px',
			fontStyle: 'normal',
			'font-weight': '600',
			'line-height': 'normal',
			padding:'10px 10px',
			borderTop:'solid 1px #e6e6e6',
			borderBottom:'solid 1px #e6e6e6',
			textAlign:'left',
			'&:first-child':{
				paddingLeft:20,
			},
		},
		'& td':{
			color: '#666',
			fontSize: '14px',
			fontWeight: 400,
			lineHeight: 'normal',
			padding:10,
			border:'solid 1px #e6e6e6',
			borderLeft:0,
			borderRight:0,
			borderTop:0,
			textAlign:'left',
			'&:first-child':{
				paddingLeft:20,
				width:60,
				textAlign:'center',
			},
		},
	},
	activeTag:{
		background:'#1d7dea !important',
		color:'#ffffff !important',
	},
	draftContent: {
		display: 'flex',
		flexDirection: 'row',
		gap: '10px',
		color: '#999',
		fontSize: 14,
		justifyContent: 'flex-end',
		alignItems: 'center',
		paddingTop: '4px'
	},
	createdbyUsername:{
		display:'flex',
		justifyContent:'flex-end',
		'& p':{
			width:'auto !important',
			overflow:'visible',
			textOverflow:'inherit',
			whiteSpace:'normal',
			display:'flex',
			gap:5,
		},
		'& p i':{
			fontStyle:'normal',
		},
		'& p strong':{
			maxWidth:110,
			overflow:'hidden',
			textOverflow:'ellipsis',
			whiteSpace:'nowrap',
			display:'inline-block',
			paddingLeft: 5,
		},
	},
	ratingBlock: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.31rem',
		border: '1px solid #FFE1B5',
		backgroundColor: '#FFF8ED',
		borderRadius: '0.25rem',
		padding: '0.31rem 0.63rem',
		fontSize: '0.75rem',
		lineHeight: '150%',
		fontWeight: 600,
		color: '#333333',
		'& span': {
			fontWeight: 400,
			color: '#1D7DEA',
		},
		'& img': {
			width: '0.75rem',
		}
	}
});

//@ts-ignore
interface ContentCardProps extends WithStyles<typeof styles> {
	classes: any,
	content: ContentData,
	userId: string,
	contentType: any,
	contentSubtype: any,
	onViewDetailsClick: Function,
	onFavouriteClick: Function,
	setContentSelected: Function,
	isInSelectedContent: Function,
	isAllSelectedContent: boolean;
	index: number,
	fromCourse: Boolean,
	fromTestPaper: Boolean,
	isInDisableContent: (_id: string, contentId: string) => boolean,
	hideAuthor: any;
	hideSelectOption:any
}
interface ContentCardState{
	showDropdown: boolean,
	isModalOpen: boolean,
	selectedModalTab: any,
	contentModalInfo: any,
}
class ContentCard extends Component<ContentCardProps, ContentCardState>{
	defaultContent: any = null;
	contentTypeIcon: any = {
		"question": "/assets/svg/myLibrary/question.svg",
		"studymaterial": "/assets/svg/myLibrary/notes.svg",
		"sampleproblem": "/assets/img/myLibrary/content-type/notes.svg",
		"formulas": "/assets/svg/myLibrary/formulas.svg",
		"videos": "/assets/svg/myLibrary/Video.svg",
		"cppSubjective": '/assets/svg/createContent/cppSubjective.svg',
		"cppObjective": '/assets/svg/createContent/cppObjective.svg',
		"workbookSubjective": '/assets/svg/createContent/workbookSubjective.svg',
		"workbookObjective": '/assets/svg/createContent/workbookObjective.svg',
		"assignmentsSubjective":'/assets/svg/createContent/assignmentSubjective.svg',
		"assignmentsObjective": '/assets/svg/createContent/assignmentObjective.svg',
		"audios": "/assets/svg/myLibrary/AudioIcon.svg",
		"testpapers": "/assets/svg/myLibrary/test.svg",	
		"archiveSubjective":'/assets/svg/createContent/archiveSubjective.svg',
		"archiveObjective": '/assets/svg/createContent/archiveObjective.svg',	
	
	}

	constructor(public props: ContentCardProps, state: ContentCardState) {
		super(props);

		this.defaultContent = ContentDataDefault

		this.getCodeName = this.getCodeName.bind(this);
		this.onFavouriteClick = this.onFavouriteClick.bind(this);
		this.isFavourite = this.isFavourite.bind(this);
		this.state = {
			showDropdown : false,
			isModalOpen: false,
			selectedModalTab: CONTENT_CARD_MODAL_HEADERS[0],
			contentModalInfo: {chapters: [], concepts: [], goals: [], subjects: [], classes: []},
		}
	}

	componentDidMount(): void {
		const content = !this.props.content ? this.defaultContent : this.props.content;
		const contentModalInfo = this.getChaptersAndConcepts(content);
		this.setState({contentModalInfo});
	}

	getCodeName(code: string, subcode: string, content:any) {
		if (content && content.subType && this.props.contentSubtype[content.subType]) {
			return this.props.contentSubtype[content.subType];
		}
		if(content && content.testTemplateTypeId && (this.props.content.contentTypeCode || '').includes(CONTENT_TYPE.TEST_PAPERS)){
			return content.testTemplateTypeName;
		}
		if (this.props.contentSubtype[subcode]) {
			return this.props.contentSubtype[subcode];
		}
		if (this.props.contentType[code]) {
			return this.props.contentType[code];
		}
	}

	openInfoModal(event: any, selectedTab: any) {
		event.stopPropagation();
		const tabSelected = CONTENT_CARD_MODAL_HEADERS.find(header => header.key === selectedTab) || CONTENT_CARD_MODAL_HEADERS[0];
		this.setState({ isModalOpen: true, selectedModalTab: tabSelected });
	}

	closeInfoModal(event: any) {
		this.setState({isModalOpen: false});
	}

	onFavouriteClick() {
		const content = (!this.props.content ? this.defaultContent : this.props.content);

		//PLAY REVERSE
		let is = (this.isFavourite(content.favourites) ? 0 : 1)
		this.props.onFavouriteClick(this.props.index, is);
	}

	isFavourite(favourites: string[]) {
		let isFavourite = 0;
		if (favourites) {
			favourites.forEach(f => {
				if (this.props.userId == f) {
					isFavourite = 1;
				}
			})
		}
		return isFavourite;
	}

	formatPercentage(val: any) {
		return val && !isNaN(val) ? parseInt(val) : "0"
	}

	contentStatus() {
		let contentStatus: any;
		const { classes, hideAuthor } = this.props;
		const content = (!this.props.content ? this.defaultContent : this.props.content);
		content.status = (content.validationStatus || content.status || '').toLocaleUpperCase();
		const fullName = getPropertyValue(content,'aclMetaData.createdBy.id.fullName');

		if (content.status == "DRAFT") {
			contentStatus = (
				<>
					<Grid item xs={12} className={classes.draftContent}>
						<div className={classes.statusTxt}>{
							this.formatPercentage(content.completionPercent) + "%"}</div>
						<div className={classes.draftTxt}>
							Draft
						</div>
						<div className={classes.draftProgress}>
							<LinearProgress
								variant="determinate"
								classes={{
									colorSecondary: classes.colorSecondary,
									barColorPrimary: classes.colorSecondary,
									bar: classes.progressBar, root: classes.linearProgressBar
								}}
								value={content.completionPercent} />
						</div>

					</Grid>
					{/* <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{getPropertyValue(content, 'aclMetaData.createdBy.id.fullName', '')}</strong>
						</Typography>
					</Grid> */}
				</>
			);
		} else if (content.status == "PUBLISHED") {
			//sclasses.borderRightPublished.borderRight = this.border_color.borderRightPublished;
			contentStatus = (
				<>
					<Grid item xs={6}>
						<span className={`${classes.publishButton} ${classes.statusButton}`}>Published</span>
						{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span> */}
					</Grid>
					{/* !hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid> */}
				</>
			);
		} else if (content.status == "REVIEW") {
			contentStatus = (
				<>
					<Grid item className={cx(classes.inReviewButton, classes.statusButton)}>In Review</Grid>
					{/* <Grid item className={classes.statusText} style={{ opacity: 0.5, display: 'inline' }}>
						{dateService.timeSince(content.updatedAt)}
						<div></div>
					</Grid>
					<Typography variant="body1" className={classes.statusText} align="left">
						Reveiwer: <strong>{_.get(content, 'contentReviewer.fullName', "")}</strong>
					</Typography> */}
				</>
			);
		} else if (content.status == "LIVE") {
			contentStatus = (
				<>
					<Grid item className={cx(classes.liveButton, classes.statusButton)}>Live</Grid>
				</>
			);
		} else if (content.status == "PLANNED") {
			contentStatus = (
				<>
					<Grid item className={cx(classes.plannedButton, classes.statusButton)}>Planned</Grid>
					{/* <Grid item className={classes.statusText} style={{ opacity: 0.5, display: 'inline' }}>
						{dateService.timeSince(content.updatedAt)}
					</Grid> */}
				</>
			);
		} else if (content.status == "DELETED") {
			contentStatus = (
				<>
					<Grid item className={cx(classes.deleteButton, classes.statusButton)}>Deleted</Grid>
				</>
			);
		}else if (content.status == "REJECTED") {
			contentStatus = (
				<>
					<Grid item className={cx(classes.rejectedButton, classes.statusButton)}>Rejected</Grid>
					{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
					{!hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid>} */}
				</>
			);
		}else if (content.status == FEEDBACK_VALIDATOR_ACTIONS.APPROVED.toLocaleUpperCase()) {
			contentStatus = (
				<>
					<Grid item className={cx(classes.statusButton,classes.approveButton)}>Approved</Grid>
					{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
					{!hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid>} */}
				</>
			); 
		} else if(content.status === FEEDBACK_VALIDATOR_ACTIONS.IN_REVIEW.toLocaleUpperCase()){
			contentStatus = (
				<>
					<Grid item className={cx(classes.statusButton,classes.inReview)}>In Review</Grid>
					{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
					{!hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid>} */}
				</>
			); 
		} else if(content.status === FEEDBACK_VALIDATOR_ACTIONS.RE_SUBMITTED.toLocaleUpperCase()){
			contentStatus = (
				<>
					<Grid item className={cx(classes.statusButton,classes.inReview)}>Resubmitted</Grid>
					{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
					{!hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid>} */}
				</>
			); 
		} else if(content.status === FEEDBACK_VALIDATOR_ACTIONS.ACCEPTED.toLocaleUpperCase()){
			contentStatus = (
				<>
					<Grid item className={cx(classes.statusButton,classes.accepted)}>Accepted</Grid>
					{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
					{!hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid>} */}
				</>
			); 
		} else if (content.status === FEEDBACK_VALIDATOR_ACTIONS.QUEUED.toLocaleUpperCase()) {
			contentStatus = (
				<>
					<Grid item className={cx(classes.statusButton, classes.publishButton)}>Queued</Grid>
					{/* <span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
					{!hideAuthor && <Grid item xs={6}>
						<Typography variant="body1" className={classes.statusText} align="left">
							Created By: <strong>{fullName}</strong>
						</Typography>
					</Grid>} */}
				</>
			);
		}

		return contentStatus;
	}


	redirectToURL = () => {

	}

	getContentData = () => {
		const content = (!this.props.content ? this.defaultContent : this.props.content);
		let contentData = _.get(content, "contentId", "")
		if (content.passageData && content.passageData.length > 0) {
			contentData = content.passageData.slice(0,2).map((el: any) => el.contentId).join(", ")
		}
		return contentData
	}

	renderCardClassNames = () => {
		const { content, classes } = this.props
		switch (content.contentTypeCode) {
			case "testpapers":
				return classes.testBorder
			case "question":
				return classes.questionBorder
			case "videos":
				return classes.videoBorder
			default:
				return classes.notesBorder
		}
	}

	renderClass() {
		const { content, classes }: any = this.props;
		const subTypeEnums = ['cppSubjective','cppObjective','workbookSubjective','workbookObjective','assignmentsSubjective','assignmentsObjective','archiveSubjective','archiveObjective'];
		if (!content || !content.subType) {
			return;
		}
		if (content.subType && subTypeEnums.includes(content.subType)) {
			if (content.subType.includes('cpp')) {
				return classes.cppBorder
			}
			if (content.subType.includes('workbook')) {
				return classes.workbookBorder
			}
			if (content.subType.includes('assignment')) {
				return classes.assignmentBorder
			}
			if (content.subType.includes('archive')) {
				return classes.archive;
			}
		}
	}
	handleVariation = () =>{
        this.setState({
            showDropdown: !this.state.showDropdown
        })
	}

	redirectUrl = (id: any, e: any, vKey?: number) => {
		const content: any = this.props.content;
		e.stopPropagation();
		let url = "/content/preview/" + id
		if(vKey) {
			url = `${url}?vKey=${vKey}`
		} else if(content.contentValidationAuthorActionDue){
			url =`content/edit/${content.contentTypeCode}/${content.contentSubTypeCode}/${id}`
		} 
		window.open(url, '_blank')
	  }

	  renderQuestionVariations() {
		const {content: {questionVariations, contentTypeCode}, isAllSelectedContent, classes, isInSelectedContent, isInDisableContent,hideSelectOption} = this.props
		return (questionVariations || []).map((content: any, index: number) => {
		  const isSelected = isInSelectedContent(content._id, content.content_Id, content.passageData) || isAllSelectedContent;
		  const email = _.get(content, 'aclMetaData.createdBy.id.email', '');
		  const nameFromEmail = _.head(email.split('@'));
		  const createdByName = _.get(content, 'aclMetaData.createdBy.id.fullName', nameFromEmail);
		  return (
			<Grid container justify="flex-start" onClick={(e) => { this.redirectUrl(content._id+contentTypeCode, e, index+1) }}>
			  <Grid className={classes.grayCard}>
				{!hideSelectOption && <span className={classes.variationCardChekbox}>
				  <Checkbox
					checked={isSelected}
					onClick={(evt: any) => {
					  evt.stopPropagation();
					  this.onSelectCard(content, evt.target.checked, evt)
					} }
					classes={{
					  root: classes.checkbox,
					  checked: classes.checkedCheckbox,
					  colorPrimary: classes.primaryColor
			}}
					color="primary"
			disabled={isInDisableContent(content._id, content.content_Id)} disableRipple />
				</span>}
				<Grid container justify="space-between" alignItems="center">
				  <Grid item className={classes.width90Per}>
					<Typography className={classes.quesNumber}>
					  {content.contentId} <span>(Variation {index+1})</span>
					</Typography>
			{content.content[0] && 
					<Typography className={classes.quesHeading} dangerouslySetInnerHTML={{__html: content.content[0].questionContent}}>
					  </Typography>
			}
					<Typography className={classes.creatorName}>
					  Created by: <span>{_.capitalize(createdByName || '')}</span>
					</Typography>
				  </Grid>
				  <Grid item>
					<span>
					  <img src="/assets/svg/myLibrary/pagination/arrow-right.svg" />
					</span>
				  </Grid>
				</Grid>
			  </Grid>
			</Grid>
		  );
		})
	  }

	getContentDelayStatus = (content: any) => {
		let status = '';
		const penaltyPoints = Math.abs(content.penaltyPoints);
		if (content.contentValidationAuthorActionDue) {
			status = CARD_STATUS.ACTION;
		} else if ((content.status || '').toLocaleUpperCase() === FEEDBACK_VALIDATOR_ACTIONS.RE_SUBMITTED.toLocaleUpperCase()) {
			const updatedDate = new Date(content.updatedAt);
			const dueDate = getDiffOnTwoDates(new Date(), new Date(updatedDate.getFullYear(), updatedDate.getMonth(), updatedDate.getDate() + 8));
			status = `${CARD_STATUS.DUE} ${dueDate} day${dueDate > 1 ? 's' : ''}`;
		} else if (penaltyPoints) {
			status = `${CARD_STATUS.PENALTY}: ${penaltyPoints} ${CARD_STATUS.POINT}${penaltyPoints > 1 ? 's' : ''}`;
		}

		return status;
	}

	onSelectCard = (content: any, b: any, e?: any) => {
		if(e) e.stopPropagation();
		this.props.setContentSelected(content, b)
	}

	fetchContentIcon = (content: any) => {
		let iconType = content.contentTypeCode
		if (content.subType) {
			iconType = content.subType
		}
		if (content.contentSubTypeCode === 'videos') {
			iconType = content.contentSubTypeCode
		} else if (content.contentSubTypeCode === 'audios') {
			iconType = content.contentSubTypeCode
		}
		return this.contentTypeIcon[iconType];
	}

	getChaptersAndConcepts = (content: any) => {
		let chapters: any = [], concepts: any = [], goals: any = [], classes: any = [], subjects: any = [];
		const classesSet = new Set();
		((content.contentDetails || {}).subjects || []).forEach((subject: any) => {
			subjects.push(subject.name || '');
			(subject.chapters || []).forEach((chapter: any) => {
				chapters.push(chapter.name);
				(chapter.concepts || []).forEach((concept: any) => {
					classesSet.add(concept.class);
					concepts.push(concept.name);
				})
			})
		});
		goals = (content.syllabusExams || []).map((goal: any) => goal.name);
		classes = Array.from(classesSet);
		return { chapters, concepts, subjects, goals, classes };
	}

	renderSelectedCardInfo() {
		const { selectedModalTab, contentModalInfo } = this.state;
		const dataToDisplay = contentModalInfo[selectedModalTab.key] || [];
		return (dataToDisplay || []).map((value: any, index: any) =>
			<tr key={index}>
				<td>{index + 1}</td>
				<td>{value}</td>
			</tr>
		)
	}

	render() {
		const { classes, isInSelectedContent, isAllSelectedContent, setContentSelected, isInDisableContent,hideSelectOption, hideAuthor } = this.props;
		const content = (!this.props.content ? this.defaultContent : this.props.content);
		const { showDropdown, isModalOpen, selectedModalTab, contentModalInfo } = this.state;
		const {questionVariations} = content;
		const contentDelayStatus = this.getContentDelayStatus(content);
		return (
			<Paper
				classes={{ root: classes.paper }}
				className={content.subType ? this.renderClass() : this.renderCardClassNames()}
				elevation={24}>

				<Grid container className={classes.mainContentArea}>
					<Grid item className={classes.cardLeftSection}>
						<Grid container justify="flex-start" alignItems="center">
							{!hideSelectOption&&<Grid item>
								<Checkbox
									checked={isInSelectedContent(content._id, content.content_Id, content.passageData) || isAllSelectedContent}
									onClick={(evt: any) => {
										evt.stopPropagation();
										this.onSelectCard(content, evt.target.checked)
									}}
									classes={{
										root: classes.checkbox,
										checked: classes.checkedCheckbox,
										colorPrimary: classes.primaryColor
									}}
									color="primary"
									disabled={isInDisableContent(content._id, content.content_Id)} disableRipple />
							</Grid>}
							{!hideSelectOption &&<Grid item>
								<Checkbox
									onChange={this.onFavouriteClick}
									className={classes.favourite}
									icon={!this.isFavourite(content.favourites) ?
										<img src="/assets/svg/outlinedStar.svg" width="20" height="22" alt="outlineStar" className={classes.favouriteIcon} />
										: <StarSharp classes={{ root: classes.favouriteIcon }} />}
									checkedIcon={this.isFavourite(content.favourites) ?
										<StarSharp classes={{ root: classes.favouriteIcon }} />
										: <img src="/assets/svg/outlinedStar.svg" width="20" height="22" alt="outlineStar" className={classes.favouriteIcon} />} />
							</Grid>	}						
						</Grid>						
					</Grid>
					{/* Collapsible variation link */}
					{questionVariations && questionVariations.length > 0 && 
					<Grid item className={classes.collapseLink} onClick={this.handleVariation}>
						<Typography className={(showDropdown==false) ? classes.rotateImg: classes.arrowIcon}
						>{questionVariations.length} Variations <img src="/assets/svg/myLibrary/primaryArrow.svg"/></Typography>	
					</Grid>	
					}
					{/* End Collapsible variation link */}
					{/* <MyPATLink to={`/content/preview/${content._id}`} target="_blank" className={classes.cardRightSection}>						 */}
					<div onClick={(e) => this.redirectUrl(content._id, e)} className={cx(classes.cardRightSection, { [classes.hideSelectOption]: hideSelectOption })}>						
						<Grid container direction="row">
							<Grid item xs={12}>
								<Grid container justify="space-between">
									<Grid item xs={8}>
										<Grid container justify="flex-start">
											<Grid item>
												<Typography variant="body2" className={cx(classes.title)}>
													{this.getContentData()}
													{(content.passageData || []).length > 2 &&
														<span className={classes.paragraphInfo}>
															<Tooltip classes={{tooltip: classes.paragraphTooltip}} title={
																<div className={classes.lightTooltip}>
																	{content.passageData.map((question: any) => question.contentId).join(', ')}
																</div>
															}>
																<span>
															<span className={classes.paragraphCount}>+{content.passageData.length - 2}</span> more ID{content.passageData.length > 3 ? 's' : ''}
																</span>
															</Tooltip>
														</span>
													}
												</Typography>
											</Grid>
											<Grid item>
												<Chip color="primary"
													label={this.getCodeName(content.contentTypeCode, content.contentSubTypeCode,content)}
													className={classes.contentType}
													classes={{ label: classes.chipLabel }} variant="outlined" />
											</Grid>	
											{content.status === CONTENT_STATUS.PUBLISH && content.contentRating && <div className={classes.ratingBlock}>
												<img src="/assets/svg/contentValidation/star-fill.svg" alt="Star Rating" />
												{content.contentRating} <span>({content.totalNoOfRatings}  Review{content.totalNoOfRatings > 1 ? 's' : ''})</span>
											</div>
											}
											<div className={classes.actionRequired}>
												{contentDelayStatus && <span className={classes.dueText}><img src="/assets/svg/contentValidation/validation-sign.svg" alt="Validation" /> {contentDelayStatus}</span>}
											</div>
										</Grid>
									</Grid>	
									<Grid d-flex item xs={4} className={cx(classes.alignRight, 'd-flex')}  justify="flex-end">
										<Grid item>{this.contentStatus()}</Grid>
										<span className={classes.statusText}>{dateService.timeSince(content.updatedAt)}</span>
									</Grid>																
								</Grid>
								<Grid item xs={12}>
									<Typography variant="body1"
										classes={{ root: classes.textEllipsis }}
										className={classes.subTitle}>
										<span dangerouslySetInnerHTML={{ __html: content.title ? content.title.replace(/(<\/?(?:mark)[^>]*>)|<[^>]+>/ig, "$1") : '' }}></span>
									</Typography>
								</Grid>

								<Grid container justify="space-between" alignItems="center">
									<Grid item xs={9}>
										<Grid container justify="flex-start" alignItems="center">
											<Grid item>
												<img src={this.fetchContentIcon(content)} className={content.subType ? classes.subtypeIcon : classes.contentTypeIcon} />
											</Grid> <Grid item>
												<div className={classes.classSubject}>
													{!!contentModalInfo.classes.length &&
														<Typography onClick={(event: any) => this.openInfoModal(event, CARD_INFO_TYPES.CLASSES)}>
															<span>{contentModalInfo.classes[0]}</span>
															{contentModalInfo.classes.length > 1 && <em className={classes.plusSign}>+{contentModalInfo.classes.length - 1}</em>}
														</Typography>
													}
													{!!contentModalInfo.subjects.length &&
														<Typography onClick={(event: any) => this.openInfoModal(event, CARD_INFO_TYPES.SUBJECTS)}>
															<i className={classes.dotCircle}></i>
															<span>{contentModalInfo.subjects[0]}</span>
															{contentModalInfo.subjects.length > 1 && <em className={classes.plusSign}>+{contentModalInfo.subjects.length - 1}</em>}
														</Typography>
													}
													{!!contentModalInfo.chapters.length &&
														<Typography onClick={(event: any) => this.openInfoModal(event, CARD_INFO_TYPES.CHAPTERS)}>
															<i className={classes.dotCircle}></i>
															<span>{contentModalInfo.chapters[0]}</span>
															{contentModalInfo.chapters.length > 1 && <em className={classes.plusSign}>+{contentModalInfo.chapters.length - 1}</em>}
														</Typography>
													}
													{content.contentTypeCode === AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION && !!contentModalInfo.concepts.length &&
														<Typography onClick={(event: any) => this.openInfoModal(event, CARD_INFO_TYPES.CONCEPTS)}>
															<i className={classes.dotCircle}></i>
															<span>{contentModalInfo.concepts[0]}</span>
															{contentModalInfo.concepts.length > 1 && <em className={classes.plusSign}>+{contentModalInfo.concepts.length - 1}</em>}
														</Typography>
													}
													{[AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION, AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS].includes(content.contentTypeCode) && content.syllabusExams && !!content.syllabusExams.length &&
														<Typography onClick={(event: any) => this.openInfoModal(event, CARD_INFO_TYPES.GOALS)}>
															<i className={classes.dotCircle}></i>
															<span>{content.syllabusExams[0].name}</span>
															{content.syllabusExams.length > 1 && <em className={classes.plusSign}>+{content.syllabusExams.length - 1}</em>}
														</Typography>
													}
												</div>
											</Grid>
										</Grid>
									</Grid>

									<Grid item xs={3}>
										<div className={classes.createdbyUsername}>
											{!hideAuthor && <Typography variant="body1" className={classes.statusText}>
												<i>Created By:</i> <strong title={getPropertyValue(content, 'aclMetaData.createdBy.id.fullName', "")}>{getPropertyValue(content, 'aclMetaData.createdBy.id.fullName', "")}</strong>
											</Typography>
											}
										</div>
									</Grid>
								</Grid>
							</Grid>
							{/* <Grid item xs={3}>
								<Grid container
									alignItems="center"
									spacing={8} className={classes.paddingSm}>
									{this.contentStatus()}
								</Grid>
							</Grid> */}

							{/* Variation Queation card */}
						
							{
							showDropdown && 
							<>
							{this.renderQuestionVariations()}
							</>
							}
							{/* End Variation Queation card */}
						</Grid>
					{/* </MyPATLink> */}
					{content.validationStatus === FEEDBACK_VALIDATOR_ACTIONS.QUEUED && <div className={classes.resultRegeneration}>Regeneration of the test results for this question is currently in progress</div>}
					{content.lastTestDetails && content.lastTestDetails.date && <div className={classes.lastUsedStrip}>Last Used on <b>{moment(content.lastTestDetails.date).format("Do, MMMM YYYY")} in Test ID: {content.lastTestDetails.testContentId}</b></div>}
					</div>
					
				</Grid>

				{/* <Grid container className={classes.cardFooter}>
					<Grid item style={{ maxWidth: '8%', minWidth: '90px' }}></Grid>
					<Grid item xs={10}>
						<Grid container direction="row" justify="center" alignItems="center">
							<Grid item xs={9}>
								
							</Grid>
							<Grid item xs={3}>
								<ACL
									layerType={['CONTENT']}
									accessType={['VIEW']}
								>
									<Grid container
										direction="row"
										justify="flex-start"
										alignItems="center">
									
										<Grid item xs={6}>
											<Typography inline variant="body1"
												onClick={(e: any) => { onViewDetailsClick(e, content) }}
												classes={{ root: classes.viewDetails }}>
												<span><img src="/assets/svg/myLibrary/info.svg" /></span>
												&nbsp;
												Info
											</Typography>
										</Grid>

										<Grid item xs={6}>
											<MyPATLink to={`/content/preview/${content._id}`} target="_blank">
												<Typography inline variant="body1" classes={{ root: classes.viewDetails }}>
													<span><img src="/assets/svg/myLibrary/preview.svg" /></span>
													&nbsp;
														Preview
												</Typography>
											</MyPATLink>
										</Grid>
									</Grid>
								</ACL>
							</Grid>
						</Grid>
					</Grid>
				</Grid> */}

				<Modal
					aria-labelledby="card-info"
					aria-describedby="card-content-info"
					className={classes.modal}
					open={isModalOpen}
					onClose={this.closeInfoModal.bind(this)}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}
				>
					<Fade in={isModalOpen}>
						<div className={classes.customModalBox}>
							<h2>Tagged Contents<span onClick={this.closeInfoModal.bind(this)}><img src="/assets/svg/closeModalIcon.svg" alt="close" /></span></h2>
							<div className={classes.plusMorePopup}>
								<ul>
									{CONTENT_CARD_MODAL_HEADERS.filter((header: any) => (contentModalInfo[header.key] || []).length).map((header: any, index: any) =>
										<li key={index} className={cx({ [classes.activeTag]: selectedModalTab.key === header.key })} onClick={() => { this.setState({ selectedModalTab: header }) }}>{header.value}</li>
									)}
								</ul>
								<div className={classes.contentMorePlus}>
									<PerfectScrollbar>
										<div className={classes.tableWrapper}>
											<table cellPadding={0} cellSpacing={0} className={classes.tableTagList}>
												<thead>
													<th>S.No.</th>
													<th>{selectedModalTab.value}</th>
												</thead>
												<tbody>
													{this.renderSelectedCardInfo()}
												</tbody>
											</table>
										</div>
									</PerfectScrollbar>
								</div>
							</div>
						</div>
					</Fade>
				</Modal>
			</Paper >
		);
	}
}


const mapStateToProps = (state: any) => {
	let ct: any = _.get(state, "mylibraryData.contentType.list", []);
	let ctt: any = {};
	ct.forEach((c: any) => {
		ctt[c.code] = c.name;
	});


	let contentSubTypeList: any = _.get(state, "mylibraryData.contentSubtype.list", []);
	let contentSubTypeMapToName: any = {};
	contentSubTypeList.forEach((contentSubType: any) => {
		if (contentSubType && contentSubType.contentTypeId && (contentSubType.contentTypeId.code || '').toLowerCase().includes(CONTENT_TYPE.TEST_PAPERS)) {
			contentSubTypeMapToName[contentSubType._id] = contentSubType.name;
		}
		else {
			contentSubTypeMapToName[contentSubType.code] = contentSubType.name;
		}
	});

	return {
		userId: _.get(state, "loginData.userData.authenticatedUser._id", "a"),
		contentType: ctt,
		contentSubtype: contentSubTypeMapToName,
	}
}

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(ContentCard));

